import { render, staticRenderFns } from "./SBTitle.html?vue&type=template&id=0d61e864&scoped=true&"
import script from "./SBTitle.ts?vue&type=script&lang=ts&"
export * from "./SBTitle.ts?vue&type=script&lang=ts&"
import style0 from "./SBTitle.css?vue&type=style&index=0&id=0d61e864&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d61e864",
  null
  
)

export default component.exports